import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0.31 0.31 24.5 24.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-332.189 -58.439)",
		children: [/* @__PURE__ */ _jsx("line", {
			x2: 23,
			y2: 23,
			transform: "translate(356.25 59.5) rotate(90)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("line", {
			x2: 23,
			y2: 23,
			transform: "translate(333.25 59.5)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.5
		})]
	})
});
export { SvgIconClose as ReactComponent };
